import { render, staticRenderFns } from "./BoField.vue?vue&type=template&id=4b360a38&"
import script from "./BoField.vue?vue&type=script&lang=js&"
export * from "./BoField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports